import { render, staticRenderFns } from "./MarkHomeworkV2.vue?vue&type=template&id=574f1dc0&scoped=true"
import script from "./MarkHomeworkV2.vue?vue&type=script&lang=js"
export * from "./MarkHomeworkV2.vue?vue&type=script&lang=js"
import style0 from "./MarkHomeworkV2.vue?vue&type=style&index=0&id=574f1dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f1dc0",
  null
  
)

export default component.exports